import { useEffect, useRef, useState } from 'react';
import { apiUrl } from '../config/api';
import './PartnersSection.css'; // Reuse the same CSS

interface Donor {
  id: number;
  image_url: string;
  order: number;
}

const Donors = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [donors, setDonors] = useState<Donor[]>([]);
  const [loading, setLoading] = useState(true);

  // Fetch donors
  useEffect(() => {
    fetch(apiUrl('/api/donors'))
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setDonors(data.data);
        }
      })
      .catch(err => console.error('Error:', err))
      .finally(() => setLoading(false));
  }, []);

  // Intersection Observer for fade-in animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Duplicate logos for seamless infinite scroll
  const allDonors = [...donors, ...donors];

  if (loading) {
    return (
      <section 
        id="our-donors" 
        ref={sectionRef}
        className="partners-section"
      >
        <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
          <h2 className="title-animation">
            Our Donors
          </h2>
        </div>
        <p>Loading donors...</p>
      </section>
    );
  }

  if (donors.length === 0) {
    return (
      <section 
        id="our-donors" 
        ref={sectionRef}
        className="partners-section"
      >
        <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
          <h2 className="title-animation">
            Our Donors
          </h2>
        </div>
        <p>No donors available</p>
      </section>
    );
  }

  return (
    <section 
      id="our-donors" 
      ref={sectionRef}
      className={`partners-section ${isVisible ? 'visible' : ''}`}
    >
      <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
        <h2 className="title-animation">
          Our Donors
        </h2>
      </div>

      <div className="partners-carousel">
        <div className="partners-track">
          {allDonors.map((donor, index) => (
            <div key={`${donor.id}-${index}`} className="partner-card">
              <img 
                src={donor.image_url} 
                alt={`Donor ${donor.id}`}
                loading="lazy"
                onError={(e) => {
                  console.error('Image failed to load:', donor.image_url);
                  (e.target as HTMLImageElement).src = 'https://via.placeholder.com/160x100?text=Donor';
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Donors;